import {
  API_APPLICATION_ID,
  B2B_API_BASE_URL,
  B2C_API_BASE_URL,
  SECRET_KEY,
} from "@/constants/envs";
import axios from "axios";
export type { AxiosRequestConfig as RequestConfig } from "axios";

export const b2cAxiosConfig = axios.create({
  baseURL: B2C_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 60000,
  showToastOnError: true,
});

export const b2bAxiosConfig = axios.create({
  baseURL: B2B_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    ApplicationID: API_APPLICATION_ID || "",
    SecretKey: SECRET_KEY || "",
    /**
     * 1 = web
     */
    DeviceType: "1",
  },
  timeout: 60000,
  showToastOnError: true,
});
